
var upsell_products_inputs = document.querySelectorAll('.js-hp_upsell_products--list_item');
var submit_button = document.querySelector('.quantity-submit-row__submit');

if (submit_button) {
    submit_button.addEventListener('click', ()=>{
        // initiate empty products array
        var selected_upsell_products = [];

        // START create the Main product object
        var main_product_selected_variant_id = document.querySelector('[name="id"]').value;
        var main_product_selected_qty = document.querySelector('#quantity').value;
        var main_product_object = {
            'id': main_product_selected_variant_id,
            'quantity': main_product_selected_qty
        }
        // END create the Main product object

        createArrayOfObjects(upsell_products_inputs, selected_upsell_products) // create the object for each selected product and added them to an array 

        selected_upsell_products.push(main_product_object) //Adding the main product variant and quantity to the array so it will be sent with the Ajax request

        addItemsToTheCart(selected_upsell_products) // Adding the selected items + the main product to the cart and unchecked the inputs
    });
}

/* 
    Function create array of objects of the selected Upsells items
*/
function createArrayOfObjects(arr, target){
    arr.forEach((i)=>{
        if (i.checked == true) {
            var id = parseInt(i.getAttribute('id'))
            var qty = 1;
            var item_obj = {
                'id': id,
                'quantity': qty
            }
            // Add the selected upsell products to the array
            target.push(item_obj)
        }
    })
}

/*
    Function using Ajax request to add the items to the cart
*/
function addItemsToTheCart(items_array){
    var reqBody = {
        'items': items_array
    };
    var reqConfig = {
        body: JSON.stringify(reqBody),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        
        }
    };
    
    fetch('/cart/add.js', reqConfig) // consider use 'routes.cart_add_url' make sure it is has extension .js 
        .then((response) => response.json())
        .then( uncheckedAllItems(upsell_products_inputs) )
        .then((response) => {
            if (response.status) {
                // this.handleErrorMessage(response.description);
                return;
            }
            console.log(response);
        })
}

/* 
    Function to Unchecked the list items
*/
function uncheckedAllItems(arr){
    arr.forEach((i)=>{
        i.checked = false
    })
}